import { IMember } from "@wingspanhq/users/dist/lib/interfaces";
import { FormDataAccountType } from ".";
import type { onboardingApiSpec } from "@wingspanhq/wingspan-api-types";

export function getProfileDataAccountType(
  monitoredEntity?: onboardingApiSpec.CustomerEntity,
  member?: IMember
): Partial<FormDataAccountType> {
  return {
    country: monitoredEntity?.country || member?.profile?.address?.country,
    type: monitoredEntity?.type
  };
}
